import { render, staticRenderFns } from "./LtkPostThumbnail.vue?vue&type=template&id=3969b3d9&scoped=true"
import script from "./LtkPostThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkPostThumbnail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkPostThumbnail.vue?vue&type=style&index=0&id=3969b3d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969b3d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,LtkVideoPlayer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkVideoPlayer.vue').default,TrackPostImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackPostImpression.vue').default,CImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CImg/CImg.vue').default})
